import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopBrowseTop728x90Gak from './gak/DesktopBrowseTop728x90';
import DesktopBrowseTop728x90Hashtag from './hashtag/DesktopBrowseTop728x90';
const DesktopBrowseTop728x90 = ({ safety = 'off', safetyState })=>{
    const isHashtag = useFlag('ads_prebid');
    if (isHashtag) {
        return /*#__PURE__*/ React.createElement(DesktopBrowseTop728x90Hashtag, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopBrowseTop728x90Gak, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopBrowseTop728x90.displayName = 'DesktopBrowseTop728x90';
export default DesktopBrowseTop728x90;
